import TournamentStageGroupMember from '../member';

export default class TournamentStageGroupTeam extends TournamentStageGroupMember {
  constructor(team = {}, url) {
    super({ ...team, is_team: true }, url);
  }
}
